import {useVirtualPaging} from "./AppContext";
import {UIComboBox} from "../tools/UIComboBox";
import {useEffect} from "react";
import {mochData} from "./MochData";
import {FilterEntry} from "./CommonUIComponenets";

export function useCombiFields({api, combis, genQueryParams, setInp, listFetch, inp, vals, cacheMins}) {
    for (let ic in combis)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        Object.assign(combis[ic], useVirtualPaging({
            noAutoFetch: true, api, params: () => ({field: combis[ic].k, ...genQueryParams()}), cacheMins,
            alt: mochData.combiFields?.(combis, ic)
        }));

    function onChangeQuery(f, v, comb, i, dontFetch) {
        if (v === inp[f] && (!["device", "param"].includes(f) || i === undefined ||
            (f === "device"? inp.iDevice : inp.iParam) === i))
            return false;         // nothing changed? in case of device/param check if i passed.

        // when a filter value changes, clear opts for other comboboxes, to force refetch.
        combis.forEach(comb => comb.k !== f && comb.silentClear());

        setInp(inp =>
            vals.inp = ({
                ...inp,
                [f]: v,
                ...f === "device" && {
                    iDevice: i,
                    deviceId: comb.rsp?.deviceIds[i]
                },
                ...f === "param" && {
                    iParam: i,
                    paramExtra: comb.rsp?.paramExtra[i]
                },
            })
        );

        if (!dontFetch)
            listFetch?.();
        return true;            // value changed - in case parent wants to perform something.
    }

    return {combis, onChangeQuery};
}

export function UICombiFieldFilter({combi, value, opts, onChangeQuery, onSelectSearch, ...props}) {

    return <FilterEntry title={combi.h}>
        <UIComboBox
            classNameWrapper="w-full" noOptsFilter
            value={value}
            opts={opts || combi.rsp?.data}
            placeholder="All"
            optsVer={combi.rspVer}
            onPopPanel={!combi.rsp && (() => combi.fetch())}        // ensure fetch is not called with onPopPanel's parameter.
            onChange={(f, v, isShown) => (onChangeQuery(f, v, combi))}
            onSelect={(f, v, i) => onChangeQuery(f, v, combi, i)}
            onPaging={combi.onPaging}
            {...props}
        />
    </FilterEntry>
}

export function UIDelayedCombiField({combi, value, opts, onChangeQuery, onSelectSearch, ...props}) {

    useEffect(() => {
        const delayedFetch = setTimeout(() => combi.fetch(), 1000);

        return () => clearTimeout(delayedFetch);
    }, [value]);

    return <UIComboBox
        classNameWrapper="w-full" noOptsFilter
        className="h-[3.75rem] text-lg focus:ring-prm-dark focus:shadow-[0_0_10px_0_#4897FF] w-full focus:ring-2 outline-none"
        classNameListItem={"border-y border-divider py-2 bg-bg2 rounded"}
        value={value}
        opts={opts}
        optsVer={combi.rspVer}
        onPopPanel={!combi.rsp && (() => combi.fetch())}
        onChange={(f, v, isShown) => (onChangeQuery(f, v, combi))}
        onSelect={(f, v, i) => (onChangeQuery(f, v, combi, i), onSelectSearch(f,v,i))}
        onPaging={combi.onPaging}
        {...props}
    />
}